import type { FeatureStoryContent } from "../types";

/** 专题故事：宽幅叙事横幅（参考 about.google 的 story feature） */
export function renderStory(story: FeatureStoryContent): string {
  return `
    <section class="section story-section" id="${story.id}">
      <div class="story" data-reveal>
        <div class="story-kicker">${story.kicker}</div>
        <h2>${story.title}</h2>
        <p class="story-lede">${story.lede}</p>
        <a href="${story.cta.href}" class="btn ${story.cta.variant}">${story.cta.label}</a>
      </div>
    </section>`;
}
